import { IPreferencesUser } from "@/features/financas/views/Indicadores/@types/type";
import { IUsePreferenceStoreMixins } from "./IUsePreferenceStoreMixins";
import { useUserPreferencesStore } from "./userPreferencesStore";
import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class UsePreferenceStoreMixinsAdapter
  implements IUsePreferenceStoreMixins
{
  private readonly preferenceStore: ReturnType<typeof useUserPreferencesStore>;

  constructor() {
    this.preferenceStore = useUserPreferencesStore();
  }

  setPreferences(data: IPreferencesUser[] | []): void {
    this.preferenceStore.setPreferences(data);
  }

  updateDefault(preferenceList: IPreferencesUser[]): void {
    this.preferenceStore.updateDefault(preferenceList);
  }

  obterPreferencias() {
    const { preferences } = this.preferenceStore;

    return preferences;
  }
}
